import { AuthContext } from "contexts/AuthContext";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { passwordValidations as validations } from "utils/validations/loginValidations";
import useForm from "hooks/useForm";
import useQuery from "hooks/useQuery";
import Container from "components/Library/Container";
import Form from "components/Library/Form";
import Button from "components/Library/Button";
import Input from "components/Library/Input";

function ResetPassword() {
  const authContext = useContext(AuthContext);
  const query = useQuery();
  const [loading, setLoading] = useState(false);
  const [formValues, handleInputChange, errors, setErrors] = useForm({
    password: "",
    password2: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formErrors = validations(formValues);
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const oobCode = query.get("oobCode");
      authContext.resetPassword(oobCode, formValues.password);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    setErrors(authContext.errorMessage);
    setLoading(false);
  }, [setErrors, authContext.errorMessage]);

  return (
    <Container>
      <Form
        className="form form--sm"
        onSubmit={handleSubmit}
        autoComplete="off"
      >
        <h1 className="form__title">Restaurar contraseña</h1>
        <Input
          type="password"
          placeholder="Nueva contraseña"
          name="password"
          value={formValues.password}
          error={errors.password}
          onChange={handleInputChange}
        />
        <Input
          type="password"
          placeholder="Confirmar contraseña"
          name="password2"
          value={formValues.password2}
          error={errors.password2}
          onChange={handleInputChange}
        />
        <div className="form__buttons">
          <Link className="button button--secondary" to="/">
            Regresar
          </Link>
          <Button type="submit" value="Restaurar" disabled={loading} />
        </div>
      </Form>
    </Container>
  );
}

export default ResetPassword;
